import { useSelector } from "react-redux";

export function useSubscription() {
  const privileges = useSelector(
    (state) => state?.privilegesReducer?.subscriptionPrivileges,
  );
  function hasSubscription(permission, privilegesList) {
    if (privilegesList != null) {
      let _privileges = [];
      if (typeof privilegesList === "string") {
        _privileges = privilegesList.split(",").map((p) => p.trim());
      } else if (Array.isArray(privilegesList)) {
        _privileges = privilegesList;
      }
      return permission.every((p) => _privileges.includes(p));
    }
    return permission.every((p) => privileges.includes(p));
  }

  return { hasSubscription, privileges };
}
